import { useState } from 'react';
import Button from '@material-ui/core/Button';
import { Alert, Skeleton } from "@material-ui/lab";

import useContext, { retryQuote } from "../../context";
import { getAvailableTerms } from "../../loanConfig";
import Card from "./components/Card";
import EmptyCreditCheckCard from "./components/EmptyCreditCheckCard";
import EmailQuoteModal from './components/EmailQuoteModal';

function ErrorState({ error }) {
  return (
    <div className="quoteform__content">
      <Alert
        severity="error"
        action={error.retryable && <Button color="inherit" size="small" onClick={retryQuote}>Try again</Button>}
      >
        {error.message}
      </Alert>
      <div className="quoteform__options">
        <Skeleton rectangular width={300} height={400} style={{margin: 16}}/>
        <Skeleton rectangular width={300} height={400} style={{margin: 16}}/>
      </div>
    </div>
  )
}

export default function LoanCards() {
  const [emailModalOpen, setEmailModalOpen] = useState(false);

  const [context] = useContext();

  if (context.config.error) {
    return <ErrorState error={context.config.error} />;
  }

  if (context.response.error) {
    return <ErrorState error={context.response.error} />;
  }

  if (!context.active) {
    const terms = getAvailableTerms(context.config, null);

    return (
      <div className="quoteform__content">
        <div className="quoteform__ready">
          <div className="quoteform__ready-title">
            Use our instant quote tool to estimate your DVC financing options with Monera Financial.
          </div>
          <div className="quoteform__ready-content">
            <ul>
              <li>Competitive rates starting at 9.9%</li>
              <li>As little as 5% down payment</li>
              <li>No credit check required </li>
              {terms.length > 0 && <li>Finance for up to {terms[terms.length - 1]} years</li>}
              <li>No loan points reported to credit bureaus </li>
              <li>No prepayment penalty and no service fee</li>
            </ul>
          </div>
        </div>
      </div>
    )
  };

  // Nothing to show until the first quote for these inputs arrives
  if (!context.response.noCreditCheck || !context.response.noCreditCheck.monthly_payment) {
    return (
      <div className="quoteform__content">
        <h2 className="quoteform__quotes-title">Your Quotes</h2>
        <div className="quoteform__options" aria-busy="true">
          <Skeleton rectangular width={300} height={400} style={{margin: 16}}/>
          <Skeleton rectangular width={300} height={400} style={{margin: 16}}/>
        </div>
      </div>
    );
  }

  const isStale = context.response.loading;

  return (
    <React.Fragment>
      <div className="quoteform__content">
        <h2 className="quoteform__quotes-title">Your Quotes</h2>
        <div className={`quoteform__options ${isStale ? 'quoteform__options--stale' : ''}`} aria-busy={isStale}>
          <Card option="noCreditCheck" disabled={isStale} openEmailModal={() => setEmailModalOpen(true)} />
          {
            context.creditRating > -1
              ? <Card option="creditCheck" disabled={isStale} openEmailModal={() => setEmailModalOpen(true)} />
              : <EmptyCreditCheckCard />
          }
        </div>
      </div>
      <EmailQuoteModal open={emailModalOpen} setOpen={setEmailModalOpen} />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanCards/index.js